import { memo } from 'react';

import { ShowcaseDescriptionSetting } from '~/components/ShowcaseModal/components/ShowcaseDescriptionSetting';
import { ShowcaseNameSetting } from '~/components/ShowcaseModal/components/ShowcaseNameSetting';

export const CreateShowcaseModalLinkDetailsFields = memo(() => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <span className="text-14 text-gray-12">Showcase name</span>
        <ShowcaseNameSetting />
      </div>
      <div className="flex flex-col gap-2">
        <span className="text-14 text-gray-12">Description</span>
        <ShowcaseDescriptionSetting />
      </div>
    </div>
  );
});

CreateShowcaseModalLinkDetailsFields.displayName = 'CreateShowcaseModalLinkDetailsFields';
